import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
// import RequestType from "@/components/requests/internal/RequestType.vue";
import ColorInternarStatus from "@/components/functionals/ColorInternarStatus";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import ColorInternarRequest from "@/components/functionals/ColorInternarRequest";
// import GetRate from "@/components/requests/internal/GetRate.vue";

export default [
  {
    prop: "Id",
    label: "No",
    minWidth: 80,
    fixed: true,
    sortable: true,
    formatter: ColorInternarRequest
  },
  {
    prop: "CreatedAt",
    label: "Fecha Creación",
    minWidth: 120,
    attrs: {
      onlyDate: true
    },
    formatter: DatetimeFormatter
  },
  {
    prop: "DisplayType",
    label: "Tipo de Solicitud",
    minWidth: 250
    // formatter: RequestType
  },
  {
    prop: "DisplaySla",
    label: "Sla (dias)",
    minWidth: 100
  },
  {
    prop: "DiasRetrasadosSla",
    label: "Atraso",
    minWidth: 120
  },
  {
    prop: "StatusSlaDescripcion",
    label: "Cumplimiento",
    minWidth: 130,
    formatter: ColorInternarStatus
  },
  {
    prop: "corta",
    label: "Descripcion",
    minWidth: 250
    //formatter: row => `${row.corta ? row.corta.substring(0, 30) : ""}...`
  },
  // {
  //   prop: "Valoracion",
  //   label: "Calificacion",
  //   minWidth: 200,
  //   formatter: GetRate
  // },
  {
    prop: "CreateBy",
    label: "Creado Por",
    minWidth: 250,
    formatter: ImagePerson,
    attrs: {
      imgKey: "CreatorImage"
    }
  },
  {
    prop: "DisplayResponsable",
    label: "Responsable",
    minWidth: 250,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ResponsableImage"
    }
  },
  {
    prop: "Supervisor",
    label: "Supervisor",
    minWidth: 250,
    formatter: ImagePerson,
    attrs: {
      imgKey: "SupervisorImage"
    }
  }
  // {
  //   prop: "ComentarioValoracion",
  //   label: "Comentario Valoración",
  //   minWidth: 250
  // }
];
